
const GLOBAL_CLEAR = 'GLOBAL_CLEAR';
const GET_WX_CONFIG = 'GET_WX_CONFIG';
const GET_WX_AGENT_CONFIG = 'GET_WX_AGENT_CONFIG';


const ACTION_TYPES = {
  GLOBAL_CLEAR,
  GET_WX_CONFIG,
  GET_WX_AGENT_CONFIG,
};

const ACTION = {
};

const Global = {
  ACTION_TYPES,
  ACTION
}

export default Global;